import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import dayjs from "dayjs";

import { getImage, getBoard } from "src/utils/Firebase";
import { deleteBoard } from "src/redux/board/actions";
import avatarImg from "../Boards/assets/Main.jpeg";

import css from "./index.scss";

const cx = classnames.bind(css);
const moduleName = "BoardDetail";

const BoardDetail = ({ match, deleteBoard }) => {
  const { params: { id } = {} } = match;
  const boardId = Number(id);

  const [post, setPost]         = useState(null);
  const [imgUrls, setImgUrls]   = useState([]);
  const [comments, setComments] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [author, setAuthor]     = useState("");
  const [comment, setComment]   = useState("");
  const [submitting, setSubmitting] = useState(false);

  const password = window.localStorage.getItem("passwordForSignIn");

  useEffect(() => {
    // 게시글 데이터 로드
    getBoard()
      .orderByChild("id")
      .equalTo(boardId)
      .once("value")
      .then((snap) => {
        const val = snap.val();
        if (!val) { setRedirect(true); return; }
        const data = Object.values(val)[0];
        setPost(data);
      });

    // 이미지 로드
    getImage()
      .child(`/board${boardId}.jpg`)
      .getDownloadURL()
      .then((url) => setImgUrls([url]))
      .catch(() =>
        getImage()
          .child(`/board${boardId}.jpeg`)
          .getDownloadURL()
          .then((url) => setImgUrls([url]))
          .catch(() => {})
      );

    // 댓글 로드
    getBoard()
      .orderByChild("id")
      .equalTo(boardId)
      .once("value")
      .then((snap) => {
        const val = snap.val();
        if (!val) return;
        const data = Object.values(val)[0];
        if (data.comment) setComments(Object.values(data.comment));
      });
  }, [boardId]);

  const handleDelete = () => {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;
    getBoard()
      .orderByChild("id")
      .equalTo(boardId)
      .once("value")
      .then((snap) => {
        const key = Object.keys(snap.val())[0];
        getBoard().child(key).remove().then(() => {
          deleteBoard();
          setRedirect(true);
        });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!author.trim() || !comment.trim()) return;
    setSubmitting(true);
    getBoard()
      .orderByChild("id")
      .equalTo(boardId)
      .once("value")
      .then((snap) => {
        const key = Object.keys(snap.val())[0];
        getBoard()
          .child(key)
          .child("comment")
          .push({ author, content: comment })
          .then(() => setRedirect(true));
      });
  };

  if (redirect) return <Redirect to="/board" />;
  if (!post) return null;

  const images = post.imgUrl && post.imgUrl.length > 0 ? post.imgUrl : imgUrls;

  return (
    <div className={cx(moduleName)}>
      <div className={cx(`${moduleName}-card`)}>
        {/* 카드 헤더 */}
        <div className={cx(`${moduleName}-card-header`)}>
          <img src={avatarImg} alt="avatar" className={cx(`${moduleName}-avatar`)} />
          <div className={cx(`${moduleName}-card-header-info`)}>
            <span className={cx(`${moduleName}-username`)}>스테이 무릉도원</span>
            <span className={cx(`${moduleName}-card-date`)}>
              {post.date ? dayjs(post.date).format("YYYY년 MM월 DD일") : ""}
            </span>
          </div>
          {password && (
            <div className={cx(`${moduleName}-actions`)}>
              <Link to={`/update/${boardId}`} className={cx(`${moduleName}-action-btn`)}>
                수정
              </Link>
              <button
                className={cx(`${moduleName}-action-btn`, `${moduleName}-action-btn--delete`)}
                onClick={handleDelete}
              >
                삭제
              </button>
            </div>
          )}
        </div>

        {/* 이미지 */}
        {images.length > 0 && (
          <div className={cx(`${moduleName}-images`)}>
            {images.map((img, i) => (
              <img key={i} src={img} alt={post.title} className={cx(`${moduleName}-image`)} />
            ))}
          </div>
        )}

        {/* 본문 */}
        <div className={cx(`${moduleName}-body`)}>
          <h2 className={cx(`${moduleName}-title`)}>{post.title}</h2>
          <p className={cx(`${moduleName}-content`)}>{post.content}</p>
        </div>

        {/* 댓글 */}
        <div className={cx(`${moduleName}-comments`)}>
          <p className={cx(`${moduleName}-comments-label`)}>댓글 {comments.length}개</p>

          {comments.length > 0 && (
            <div className={cx(`${moduleName}-comments-list`)}>
              {comments.map((c, i) => (
                <div key={i} className={cx(`${moduleName}-comment-item`)}>
                  <img src={avatarImg} alt="avatar" className={cx(`${moduleName}-comment-avatar`)} />
                  <div className={cx(`${moduleName}-comment-item-body`)}>
                    <span className={cx(`${moduleName}-comment-author`)}>{c.author}</span>
                    <span className={cx(`${moduleName}-comment-text`)}>{c.content}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {comments.length === 0 && (
            <p className={cx(`${moduleName}-no-comment`)}>첫 댓글을 남겨보세요</p>
          )}

          <form className={cx(`${moduleName}-comment-form`)} onSubmit={handleSubmit}>
            <input
              type="text"
              className={cx(`${moduleName}-comment-input`)}
              placeholder="닉네임"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
            />
            <div className={cx(`${moduleName}-comment-row`)}>
              <textarea
                className={cx(`${moduleName}-comment-textarea`)}
                placeholder="댓글 달기…"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows={2}
              />
              <button
                type="submit"
                className={cx(`${moduleName}-comment-submit`)}
                disabled={submitting || !author.trim() || !comment.trim()}
              >
                게시
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className={cx(`${moduleName}-back`)}>
        <Link to="/board" className={cx(`${moduleName}-back-link`)}>← 목록으로</Link>
      </div>
    </div>
  );
};

export default connect(
  null,
  { deleteBoard }
)(BoardDetail);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/BoardDetail/index.js